<template>
  <div>
    <div class="addressForm">
      <div class="content">
        <h1 class="mb-6 md:text-center">Dove possiamo spedire la carta?</h1>

        <div class="flex flex-wrap mb-6">
          <div class="w-full px-3 mb-6">
            <div class="tnb-input" :class="{ error: $v.shipment.$error }">
              <PlacesAutocomplete
                id="shipmentFullAddress"
                label="Indirizzo di spedizione"
                :onSelect="onSelectShipmentAddress"
                :onBlur="validateShipment"
                v-model="$v.shipment.fullAddress.$model"
              />
              <ValidationText :value="$v.shipment.fullAddress" />
            </div>
            <p
              @click="openModal('modalShipment')"
              style="font-size: 11px;"
              class="link mt-2"
              :class="{ error: $v.shipment.$error }"
            >
              Oppure inseriscilo manualmente
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- SHIPMENT -->
    <form id="spedizione">
      <Modal id="modalShipment" title="Aggiungi il tuo indirizzo di spedizione">
        <template v-slot:content>
          <div class="flex flex-wrap mb-3">
            <div class="w-full px-3 mb-3">
              <div
                class="tnb-input"
                :class="{ error: $v.shipment.country.$error }"
              >
                <label for="shipmentCountry">Nazione</label>
                <select
                  v-model.trim="$v.shipment.country.$model"
                  @change="
                    () => {
                      shipment.province = '';
                      shipment.city = '';
                    }
                  "
                  class="tnb-select"
                  id="shipmentCountry"
                >
                  <option value=""></option>
                  <option value="I">Italia</option>
                  <option
                    v-for="country in countries"
                    v-bind:value="country.code"
                    v-bind:key="country.code"
                  >
                    {{
                      country.name.charAt(0).toUpperCase() +
                        country.name.toLowerCase().slice(1)
                    }}
                  </option>
                </select>
                <ValidationText :value="$v.shipment.country" />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap mb-3">
            <div class="w-1/2 px-3 mb-3">
              <div
                class="tnb-input"
                v-if="provinces"
                :class="{ error: $v.shipment.province.$error }"
              >
                <label for="shipmentProvince">Provincia</label>
                <input
                  v-if="shipment.country !== 'I'"
                  onkeypress="return /[a-z]/i.test(event.key)"
                  maxlength="2"
                  v-uppercase
                  id="shipmentProvince"
                  class="input-text w-full"
                  v-model.trim="$v.shipment.province.$model"
                />
                <vue-simple-suggest
                  v-else
                  v-model.trim="$v.shipment.province.$model"
                  :list="provinces"
                  @blur="checkProvinceValidity('shipment')"
                  :filter-by-query="true"
                >
                </vue-simple-suggest>
                <ValidationText :value="$v.shipment.province" />
              </div>
            </div>
            <div class="w-1/2 px-3 mb-3">
              <div class="tnb-input" :class="{ error: $v.shipment.cap.$error }">
                <label for="shipmentCap">CAP</label>
                <input
                  id="shipmentCap"
                  class="input-text w-full"
                  v-model.trim="$v.shipment.cap.$model"
                  :disabled="$v.shipment.province.$error"
                  maxlength="5"
                />
                <ValidationText :value="$v.shipment.cap" />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap mb-3">
            <div class="w-full px-3 mb-3">
              <div
                class="tnb-input"
                :class="{ error: $v.shipment.city.$error }"
              >
                <label for="shipmentCity">Comune</label>
                <input
                  id="shipmentCity"
                  v-uppercase
                  v-if="shipment.country !== 'I'"
                  v-address
                  class="input-text w-full"
                  v-model.trim="$v.shipment.city.$model"
                />
                <vue-simple-suggest
                  v-else
                  v-model.trim="$v.shipment.city.$model"
                  :disabled="$v.shipment.cap.$error"
                  @blur="
                    () => {
                      sanitizeCityString('shipment');
                    }
                  "
                  :list="
                    query => {
                      return getCommunesList('shipment', query);
                    }
                  "
                ></vue-simple-suggest>
                <ValidationText :value="$v.shipment.city" />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap mb-3">
            <div class="w-2/3 px-3 mb-3">
              <div
                class="tnb-input"
                :class="{
                  error: $v.shipment.address.$error,
                  warning:
                    !$v.shipment.address.$error &&
                    shipmentAddressContainsNumbers
                }"
              >
                <label class="with-icon" for="shipmentAddress">Indirizzo</label>
                <div
                  class="icon icon-info icon--s next-to-label"
                  v-tooltip="
                    'Inserire esclusivamente l\'indirizzo, senza il numero civico o altre informazioni. Non sono ammessi caratteri speciali'
                  "
                ></div>
                <input
                  id="shipmentAddress"
                  class="input-text w-full"
                  v-model.trim="$v.shipment.address.$model"
                  v-address
                />
                <ValidationText :value="$v.shipment.address" />
                <div
                  class="validation-text"
                  v-if="
                    !$v.shipment.address.$error &&
                      shipmentAddressContainsNumbers
                  "
                >
                  <p>
                    Hai inserito dei numeri nel campo indirizzo, assicurati di
                    non includere il numero civico
                  </p>
                </div>
              </div>
            </div>
            <div class="w-1/3 px-3 mb-3">
              <div
                class="tnb-input"
                :class="{ error: $v.shipment.houseNumber.$error }"
              >
                <label class="with-icon" for="ShipmentHouseNumber"
                  >Civico</label
                >
                <div
                  class="icon icon-info icon--s next-to-label"
                  v-tooltip="
                    'Inserisci esclusivamente il civico. Sono ammessi anche caratteri come / o -'
                  "
                ></div>
                <input
                  id="ShipmentHouseNumber"
                  class="input-text w-full"
                  autocomplete="null"
                  maxlength="8"
                  :disabled="$v.shipment.address.$invalid"
                  v-model.trim="$v.shipment.houseNumber.$model"
                />
                <ValidationText :value="$v.shipment.houseNumber" />
              </div>
            </div>
          </div>
        </template>
        <template v-slot:buttons>
          <button
            class="btn btn--outline"
            @click="closeModal('modalShipment')"
            type="button"
          >
            Annulla
          </button>
          <button
            class="btn"
            type="button"
            @click="setShipmentFullAddress"
            :disabled="
              $v.shipment.country.$invalid ||
                $v.shipment.province.$invalid ||
                $v.shipment.cap.$invalid ||
                $v.shipment.city.$invalid ||
                $v.shipment.address.$invalid ||
                $v.shipment.houseNumber.$invalid
            "
          >
            Ok
          </button>
        </template>
      </Modal>
    </form>
    <div class="page-footer">
      <button class="btn" :disabled="isInvalidForm" type="button" @click="next">
        Prosegui
      </button>
    </div>
  </div>
</template>

<script>
import { numeric, minLength, maxLength } from "vuelidate/lib/validators";
import ValidationText from "@/components/ValidationText";
import PlacesAutocomplete from "@/components/PlacesAutocomplete";
import validations from "@/utils/validations";
import Modal from "@/components/Modal";
import LookupsService from "@/services/LookupsService";
import RegistrationService from "@/services/RegistrationService";
import UtilityService from "@/services/UtilityService";
import ApiService from "@/services/ApiService";
import WalletService from "@/services/WalletService";
import VueSimpleSuggest from "vue-simple-suggest";
import store from "@/store";

export default {
  name: "NameForm",
  components: {
    ValidationText,
    PlacesAutocomplete,
    Modal,
    VueSimpleSuggest
  },
  data() {
    return {
      shipment: {
        fullAddress: "",
        country: "Italia",
        province: "",
        cap: "",
        city: "",
        address: "",
        houseNumber: ""
      },

      countries: [],
      provinces: []
    };
  },
  validations: {
    shipment: {
      fullAddress: {
        required: true,
        ...validations.FULL_ADDRESS
      },
      country: {
        required: true
      },
      province: {
        required: true
      },
      cap: {
        required: true,
        minLength: minLength(5),
        maxLength: maxLength(5),
        numeric
      },
      city: {
        required: true,
        ...validations.CITY
      },
      address: {
        required: true,
        ...validations.ADDRESS
      },
      houseNumber: {
        required: true,
        ...validations.HOUSE_NUMBER
      }
    }
  },
  computed: {
    appReady() {
      return store.state.appReady;
    },
    shipmentAddressContainsNumbers: function() {
      return /\d/.test(this.shipment.address);
    },
    isInvalidForm: function() {
      return (
        this.$v.shipment.$error ||
        !this.shipment.country ||
        !this.shipment.province ||
        !this.shipment.cap ||
        !this.shipment.city ||
        !this.shipment.address ||
        !this.shipment.houseNumber
      );
    }
  },
  mounted() {
    if (this.appReady) {
      this.init();
    } else {
      this.$root.$on(`storeUpdated@setAppReady`, state => {
        if (state.appReady) {
          this.init();
        }
      });
    }
  },
  methods: {
    async init() {
      this.fillUpInfoFromStore();

      const hasActiveRegistration = !!this.$store.state.registrations
        .prepaidCardResource;
      if (hasActiveRegistration) {
        const currentCard = await this.getCurrentCard();
        if (currentCard && currentCard.cardType === "VIRTUAL") {
          //Skip this step if card is virtual
          this.$root.$emit("submitStep");
          return;
        }
      }

      LookupsService.getCountries().then(response => {
        this.countries = response.data.countries;
      });
      LookupsService.getProvinces().then(response => {
        this.provinces = response.data.provinces;
      });
    },
    async getCurrentCard() {
      return new Promise((resolve, reject) => {
        this.$root.$emit("openGlobalLoader");
        ApiService.get("/usr/v2/prepaid-cards").then(
          response => {
            let cards = response.data;
            const currentCardId = this.$store.state.registrations
              .prepaidCardResource.id;
            const currentCard = cards.filter(c => c.id === currentCardId)[0];

            console.log(currentCard);

            this.$root.$emit("closeGlobalLoader");
            resolve(currentCard);
          },
          error => {
            this.$root.$emit("closeGlobalLoader");
            UtilityService.showErrorModal(
              "Si è verificato un errore! Riprovare più tardi"
            );
            reject(error);
          }
        );
      });
    },
    sanitize(str) {
      return UtilityService.sanitizeAddressString(str);
    },
    fillUpInfoFromStore() {
      console.log("filling up info from store... ", this.$store.state);

      const addresses =
        this.$store.state.user.addresses ||
        this.$store.state.user.details.user.addresses;
      if (!addresses) return;

      const resicence = addresses.filter(a => a.type === "RES")[0];
      const domicile = addresses.filter(a => a.type === "DOM")[0];
      let shipment = addresses.filter(a => a.type === "SPED")[0];

      if (!shipment && (domicile || resicence)) {
        shipment = domicile || resicence;
        shipment.type = "SPED";
      }

      if (shipment) {
        this.shipment.country = shipment.country;
        this.shipment.province = shipment.province;
        this.shipment.cap = shipment.postalCode;
        this.shipment.city = shipment.city;
        this.shipment.address = shipment.street;
        this.shipment.houseNumber = shipment.streetNumber;
        this.setShipmentFullAddress();
      }
    },
    onSelectShipmentAddress(place) {
      this.shipment.address = this.sanitize(place.address);
      this.shipment.houseNumber = place.houseNumber || "";
      this.shipment.cap = place.cap || "";
      this.shipment.city = this.sanitize(place.city);
      this.shipment.province = place.province;
      this.shipment.country = place.country === "ITA" ? "I" : place.country;
      this.setShipmentFullAddress();
      this.validateShipment();
    },

    validateShipment() {
      this.$v.$touch();
      setTimeout(() => {
        if (this.$v.shipment.$error || this.isInvalidForm) {
          this.openModal("modalShipment");
        }
      }, 200);
    },
    setShipmentFullAddress() {
      this.shipment.fullAddress = `${this.shipment.address} ${this.shipment.houseNumber}, ${this.shipment.cap}, ${this.shipment.city}, ${this.shipment.province}`;
      this.shipment.fullAddress = this.sanitize(this.shipment.fullAddress);
      this.closeModal("modalShipment");
    },
    openModal(modal) {
      this.$root.$emit("openModal", modal);
    },

    closeModal(modal) {
      this.$root.$emit("closeModal", modal);
    },
    getCommunesList(key, query) {
      return new Promise(resolve => {
        const req = {
          commune: query,
          province: this[key].province,
          size: 30
        };

        LookupsService.getStreetsInfo(req).then(response => {
          const r = response?.data?.communes || [];
          resolve(r);
        });
      });
    },
    sanitizeCityString(key) {
      this[key].city = this.sanitize(this[key].city);
    },
    checkProvinceValidity(key) {
      const isValid =
        this.provinces.indexOf(this[key].province.toUpperCase()) >= 0;
      this[key].province = isValid ? this[key].province.toUpperCase() : "";
    },
    async next() {
      //prevent form submit
      event.preventDefault();
      if (this.loading) return;
      this.$root.$emit("openGlobalLoader");
      this.loading = true;

      const request = {
        ship: {
          country: "I",
          province: this.shipment.province.toUpperCase(),
          city: this.shipment.city.toUpperCase(),
          street: this.shipment.address.toUpperCase(),
          streetNumber: this.shipment.houseNumber.toUpperCase(),
          postalCode: this.shipment.cap
        }
      };

      try {
        this.$store.commit("setUser", {
          addresses: request
        });
        const isUpgradePhysical = sessionStorage.getItem("cr_upgrade_physical");
        if (isUpgradePhysical) {
          const card = await WalletService.getPrepaidCard();
          const r = {
            cardInstrumentId: card.id,
            shipmentAddress: request.ship
          };
          await RegistrationService.upgradeVirtualCard(r);
        } else {
          await RegistrationService.saveAddresses(request);
          await RegistrationService.getMyRegistrations();
          await RegistrationService.upgradeRegistrationProgress(1);
        }

        this.loading = false;
        this.$root.$emit("closeGlobalLoader");
        this.$root.$emit("submitStep");
      } catch (error) {

        const errorCode = error?.response?.data?.context?.code || "";

        switch (errorCode) {
          case "WAL_010012":
            //TODO: show modal not enough balance
            this.$root.$emit("openModal", "modalBalanceError");
            break;

          default:
            UtilityService.showDefaultError(error);
            break;
        }
        this.loading = false;
        this.$root.$emit("closeGlobalLoader");
      }
    }
  }
};
</script>
<style lang="less">
.tnb-app {
  .link.error {
    color: #ef2f2f;
  }
  .tnb-input {
    label.with-icon {
      display: inline-block;
    }
    .icon.next-to-label {
      display: inline-block;
      margin-bottom: -7px;
      margin-left: 10px;
    }
  }
}
</style>
